import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Row, Col } from 'antd';
import { get, find, filter } from 'lodash';
import moment from 'moment';
import Hint from 'components/common/Hint';
import InfoBar from 'components/common/InfoBar';

import helpers from 'utils/helpers';
import {
  createOrderRequest,
  orderAvailableTimeRequest,
  autoSaveRequest,
  getAutoSaveRequest
} from 'ducks/shipments';
import { getAddressesRequest, updateAddressTypeRequest } from 'ducks/users';
import { NextButton } from 'components/Styled';
import AddressForm from './AddressForm';
import ImagePlane from 'assets/images/plane.svg';

class Address extends Component {
  state = {
    uiLoaded: false
  };

  fromAddressForm = React.createRef();
  toAddressForm = React.createRef();

  handleNext = () => {
    const {
      origin,
      destination,
      carrier,
      service,
      boxData,
      itemsData,
      isDdp,
      itemType
    } = this.props;
    const fromAddress = this.fromAddressForm.current.getFormData();
    const toAddress = this.toAddressForm.current.getFormData();

    window.dataLayer.push({
      event: 'Submit Pickup',
      ecommerce: undefined
    });

    let success = true;

    // get first submit click time
    if (this.state.formStartTime) {
      const diff = moment().diff(this.state.formStartTime, 's');
      window.dataLayer.push({
        event: 'First Submit Timer',
        ecommerce: undefined,
        pickupFormFillTime: diff,
        pickupData: {
          origin,
          destination,
          carrier,
          fromAddress,
          toAddress
        }
      });

      this.setState({
        formStartTime: false
      });
    }

    if (!fromAddress.type || !toAddress.type) {
      helpers.message.error(
        this.props.t('pickup.err_msg.type.empty'),
        'address'
      );
      return;
    }

    success = this.fromAddressForm.current.validate() && success;
    success = this.toAddressForm.current.validate() && success;
    if (!success) {
      return helpers.scrollToError();
    }

    this.props.createOrderRequest({
      origin,
      destination,
      carrier,
      service,
      boxData,
      itemsData,
      itemType,
      isDdp,
      fromAddress,
      toAddress
    });

    if (fromAddress.ref && fromAddress.toUpdate) {
      this.props.updateAddressTypeRequest({
        ref: fromAddress.ref,
        addressType: fromAddress.type
      });
    }

    if (toAddress.ref && toAddress.toUpdate) {
      this.props.updateAddressTypeRequest({
        ref: toAddress.ref,
        addressType: toAddress.type
      });
    }
  };

  autoSave = (key, data) => {
    this.props.autoSaveRequest({
      [key]: data
    });
  };

  infoBarTitle = () => {
    let raw = this.props.t('pickup.check_address');
    return {
      __html: raw
    };
  };

  infoBarContent = () => {
    let raw = this.props.t('pickup.address_alert');
    return {
      __html: raw
    };
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!prevProps.orderSuccess && this.props.orderSuccess) {
      const fromAddress = this.fromAddressForm.current.getFormData();
      const toAddress = this.toAddressForm.current.getFormData();

      fromAddress.street1 = helpers.mergeAddressStreet1(
        fromAddress.unit,
        fromAddress.street1
      );
      toAddress.street1 = helpers.mergeAddressStreet1(
        toAddress.unit,
        toAddress.street1
      );
      this.props.orderAvailableTimeRequest({
        orderRef: this.props.orderRef
      });
    }

    if (prevProps.uiLoading && !this.props.uiLoading) {
      this.setState({
        uiLoaded: true
      });
    }

    if (!prevProps.availableSuccess && this.props.availableSuccess) {
      this.props.handleNext(
        {
          orderRef: this.props.orderRef,
          shipmentData: this.props.shipmentData,
          availableData: this.props.availableData
        },
        this.props.shipmentData.carrierService
      );
    }
  }

  componentDidMount() {
    this.setState({
      formStartTime: moment()
    });

    window.dataLayer.push({
      event: 'Land Pickup Page',
      ecommerce: undefined,
      landPickup: JSON.stringify({
        origin: this.props.origin,
        destination: this.props.destination
      })
    });

    this.props.getAutoSaveRequest();

    this.props.handler.openPopup(filter(this.props.posts, ['page', 'ADDRESS']));
  }

  render() {
    if (this.props.redirect) {
      return null;
    }

    if (!this.state.uiLoaded) {
      return null;
    }

    return (
      <div
        className="quotation-content"
        style={{
          flex: '1 0 auto',
          display: 'flex',
          flexDirection: 'column',
          margin: '0 auto',
          overflowX: 'hidden',
          width: '100%',
          maxWidth: `${process.env.REACT_APP_MAX_WIDTH}px`
        }}>
        <div
          id="google-map"
          style={{
            position: 'absolute',
            width: 0,
            height: 0,
            overflow: 'hidden'
          }}></div>
        <div
          className="transparent-background"
          style={{
            background: '#f5f5f5',
            height: '43px',
            textAlign: 'center',
            marginTop: '0px'
          }}>
          <div
            style={{
              paddingTop: '10px',
              textAlign: 'center'
            }}>
            <div style={{ display: 'inline-block', paddingRight: '10px' }}>
              {helpers.responsiveImage(
                helpers.getCarrierImage(this.props.carrier),
                helpers.getCarrierText(this.props.carrier),
                helpers.getCarrierImageWidth(this.props.carrier, 0.8)
              )}
            </div>
            <span style={{ verticalAlign: 'middle' }}>
              {get(this.props.selectedService.name, this.props.t('key'))}
            </span>
          </div>
        </div>
        <InfoBar
          title={this.infoBarTitle()}
          content={this.infoBarContent()}
          t={this.props.t}
        />
        <div style={{ flex: '1 0 auto' }}>
          <div
            style={{
              padding: '25px 15px 15px'
            }}>
            <Row type="flex" align="bottom">
              <Col span={12}>
                <span
                  className="buttonTheme-color"
                  style={{
                    color: '#57D7DD',
                    fontSize: '24px',
                    fontWeight: 700
                  }}>
                  {get(
                    find(this.props.countries, ['alpha-2', this.props.origin]),
                    `name.${this.props.t('key')}`
                  )}
                </span>{' '}
                <span
                  style={{
                    color: '#2C2C2E'
                  }}>
                  {this.props.t('pickup.form.pickup_title')}
                  <Hint
                    msg={this.props.t('pickup.hints.inbound_hint')}
                    visible={this.props.origin !== 'HK'}
                  />
                </span>
              </Col>
              <Col
                span={12}
                style={{
                  textAlign: 'right'
                }}>
                <img
                  className="image-filter theme"
                  src={ImagePlane}
                  style={{
                    width: '56.2px',
                    paddingBottom: '2px'
                  }}
                  alt=""
                />
              </Col>
            </Row>
            <AddressForm
              t={this.props.t}
              country={this.props.origin}
              addresses={filter(this.props.addresses, a => {
                return a.country === this.props.origin;
              })}
              showPickup={true}
              recoverAddress={(() => {
                const { recoverFormData, origin } = this.props;

                const country = get(recoverFormData, 'fromAddress.country');

                const data =
                  country === origin ? recoverFormData.fromAddress : {};

                if (country === 'HK' && data.city) {
                  data.area = data.city;
                  delete data.city;
                }

                return data;
              })()}
              autoSave={this.autoSave}
              carrier={this.props.carrier}
              ref={this.fromAddressForm}
            />
          </div>
          <div
            style={{
              padding: '35px 15px'
            }}>
            <Row type="flex" align="bottom">
              <Col span={12}>
                <span
                  className="buttonTheme-color"
                  style={{
                    color: '#57D7DD',
                    fontSize: '24px',
                    fontWeight: 700
                  }}>
                  {get(
                    find(this.props.countries, [
                      'alpha-2',
                      this.props.destination
                    ]),
                    `name.${this.props.t('key')}`
                  )}
                </span>{' '}
                <span
                  style={{
                    color: '#2C2C2E'
                  }}>
                  {this.props.t('pickup.form.receive_title')}
                </span>
              </Col>
              <Col
                span={12}
                style={{
                  textAlign: 'right'
                }}>
                <img
                  className="image-filter theme"
                  src={ImagePlane}
                  style={{
                    width: '56.2px',
                    paddingBottom: '2px',
                    transform: 'scaleX(-1)'
                  }}
                  alt=""
                />
              </Col>
            </Row>
            <AddressForm
              t={this.props.t}
              country={this.props.destination}
              addresses={filter(this.props.addresses, a => {
                return a.country === this.props.destination;
              })}
              showPickup={false}
              showPostOfficeBoxHint={
                this.props.carrier !== 'speedpost' &&
                this.props.carrier !== 'checkout'
              }
              recoverAddress={(() => {
                const { recoverFormData, destination } = this.props;

                const country = get(recoverFormData, 'toAddress.country');

                const data =
                  country === destination ? recoverFormData.toAddress : {};

                if (country === 'HK' && data.city) {
                  data.area = data.city;
                  delete data.city;
                }

                return data;
              })()}
              autoSave={this.autoSave}
              carrier={this.props.carrier}
              ref={this.toAddressForm}
            />
          </div>
        </div>
        <div>
          <NextButton
            block
            step="true"
            type="primary"
            height={60}
            onClick={this.handleNext}
            loading={this.props.loading}>
            {this.props.t('button.next_step')}
          </NextButton>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: !!state.shipments.loading,
    orderSuccess: !!state.shipments.orderSuccess,
    availableSuccess: !!state.shipments.availableSuccess,
    shipmentData: state.shipments.shipmentData || {},
    orderRef: state.shipments.orderRef || '',
    availableData: state.shipments.availableData || {},
    user: state.auth.user || false,
    countries: state.shipments.countries || [],
    uiLoading: !!(state.users.loading || !state.shipments.getAutoSaveFinished),
    addresses: state.users.addresses || false,
    updateAddressSuccess: !!state.users.updateAddressSuccess,
    recoverFormData: state.shipments.recoverFormData || {},
    posts: state.shipments.posts || false
  };
};

const mapDispatchToProps = {
  createOrderRequest,
  updateAddressTypeRequest,
  getAddressesRequest,
  orderAvailableTimeRequest,
  getAutoSaveRequest,
  autoSaveRequest
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(Address)
);
